export const PRICES_POLL_INTERVAL = 15000;
